"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.giveawayModuleIds = void 0;
exports.giveawayModuleIds = {
    REDEEM_MODAL_MODULE_ID: 'REDEEM_MODAL_MODULE_ID',
    REDEEMED_REWARDS_MODAL_MODULE_ID: 'REDEEMED_REWARDS_MODAL_MODULE_ID',
    VERIFY_STEAM_MODAL_MODULE_ID: 'VERIFY_STEAM_MODAL_MODULE_ID',
    CREATE_GIVEAWAY_MODAL_MODULE_ID: 'CREATE_GIVEAWAY_MODAL_MODULE_ID',
    ENTRY_FAILURE_MODAL_MODULE_ID: 'ENTRY_FAILURE_MODAL_MODULE_ID',
    GIVEAWAY_TERMS_CONDITION_MODAL_MODULE_ID: 'GIVEAWAY_TERMS_CONDITION_MODAL_MODULE_ID',
    REDEEM_CONFIRMATION_MODAL_MODULE_ID: 'REDEEM_CONFIRMATION_MODAL_MODULE_ID',
};
